import React, { useMemo } from 'react';
import { css } from '@emotion/react';
import { Grid } from '@material-ui/core';
import { PrimaryButton } from '@/styles/blocks';
import { STAGES } from './constants';

const Footer = ({ state, callbacks, loading, profileControls }) => {
    const [hasSelected, canInvoice] = useMemo(() => {
        const filtered = Object.keys(state.selectedOrderIds).filter((id) => state.selectedOrderIds[id]);
        return [filtered.length > 0, filtered.every((id) => state.editableOrders[id])];
    }, [state.selectedOrderIds, state.editableOrders]);

    const hasReviewed = useMemo(
        () => (state.orders || []).some((order) => order.invoicing_status === 'PRE_APPROVED'),
        [state.orders]
    );

    return (
        <>
            <Grid
                container
                css={css`
                    padding: 1rem;
                    background-color: white;
                    justify-content: center;
                    align-items: center;
                `}
            >
                <Grid
                    item
                    css={css`
                        margin-right: 16px;
                    `}
                >
                    <PrimaryButton loading={loading.action} onClick={callbacks.exportCsv} disabled={!hasSelected}>
                        Export
                    </PrimaryButton>
                </Grid>
                {state.filter.stage === STAGES.PENDING_APPROVAL && state.invoicingPermissions ? (
                    <Grid item>
                        <PrimaryButton
                            loading={loading.action}
                            onClick={callbacks.approveForInvoicing}
                            disabled={!hasSelected || !canInvoice}
                        >
                            Approve for Invoicing
                        </PrimaryButton>
                    </Grid>
                ) : null}
                {state.auditEnabled && state.filter.stage === STAGES.PENDING_APPROVAL && state.invoicingPermissions ? (
                    <Grid
                        item
                        css={css`
                            margin-left: 16px;
                        `}
                    >
                        <PrimaryButton
                            loading={loading.action}
                            onClick={callbacks.approveReviewedOrders}
                            disabled={!hasReviewed}
                        >
                            Approve Reviewed Orders
                        </PrimaryButton>
                    </Grid>
                ) : null}
                {state.auditEnabled &&
                state.filter.stage === STAGES.PENDING_APPROVAL &&
                state.invoicingPermissions &&
                !state.routeRatesEnabled ? (
                    <Grid
                        item
                        css={css`
                            margin-left: 16px;
                        `}
                    >
                        <PrimaryButton
                            loading={loading.action}
                            onClick={callbacks.openAuditQueue}
                            disabled={!(state.orders?.length > 0)}
                        >
                            Audit Orders
                        </PrimaryButton>
                    </Grid>
                ) : null}
                {state.filter.stage === STAGES.READY_TO_INVOICE && state.invoicingPermissions ? (
                    <>
                        <Grid
                            item
                            css={css`
                                margin-right: 16px;
                            `}
                        >
                            <PrimaryButton
                                loading={loading.action}
                                onClick={callbacks.createInvoices}
                                disabled={!hasSelected || !canInvoice}
                            >
                                Create Invoice
                            </PrimaryButton>
                        </Grid>
                        <Grid item>
                            <PrimaryButton
                                loading={loading.action}
                                onClick={callbacks.createMultipleInvoices}
                                disabled={!hasSelected || !canInvoice}
                            >
                                Create Multiple Invoices
                            </PrimaryButton>
                        </Grid>
                    </>
                ) : null}
                {profileControls ? (
                    <Grid
                        item
                        css={css`
                            margin-left: 16px;
                        `}
                    >
                        {profileControls}
                    </Grid>
                ) : null}
            </Grid>
        </>
    );
};

export default Footer;
